/**
 * @ngdoc component
 * @name common.component.account:ItxPhoneValidation
 * @description
 * Validates user via phone SMS
 * @param {string} email - User email
 */
(function () {

    'use strict';

    var ItxPhoneAccountCreationCmp = {
        bindings: {
           parentForm: '<',
           onUpdate: '&',
           model: '=',
        },
        controller: ItxPhoneAccountCreationCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxPhoneAccountCreationCmp.html'
    };

    ItxPhoneAccountCreationCmpCtrl.$inject = ['$scope','ItxPhoneSvc', 'acceptanceService'];


    function ItxPhoneAccountCreationCmpCtrl($scope,ItxPhoneSvc, acceptanceService) {
        var _this = this;      
        _this.SMSClicked = false;
        _this.countryCode = inditex.iCountryCode;
        _this.SMSButtonText =  inditex.text('ItxPhoneValidation.phone_verify');
        _this.visibleCodeInput = false;
        _this.serviceDown = false;
        _this.limitExceded = false;
        _this.validationModel = {
            phone: '',
            code: ''
        };

        _this.model = {}

        _this.countryPrefix =  inditex.iStoreJSON.details.phoneCountryCode
        
        _this.sendSMS = function(){
            _this.SMSButtonText = 'SENDING CODE...';
            if( _this.isChina() ){
                acceptanceService.consent( 'REGISTRO', ["transferenciaforzosa", "datossensibles"], _this.validationModel.phone );
            }
            ItxPhoneSvc.sendSMS("" ,_this.validationModel.phone).then(function(){
                _this.visibleCodeInput = true;
                _this.SMSClicked = true;
                _this.SMSButtonText = inditex.text('ItxPhoneValidation.phone_verify_resend');
                setTimeout(function(){
                    _this.SMSClicked = false;
                    $scope.$digest();
                },60000);
            }, function(error){
                if(error.errorKey && error.errorKey.indexOf('_ERR_SMS_SERVICE_DOWN') > -1){
                    _this.serviceDown = true;
                }
                else if(error.errorKey && error.errorKey.indexOf('_ERR_SMS_MAX_RETRIES') > -1){
                    _this.limitExceded = true;
                }
            });
        };

        _this.updateForm = function(){
            _this.onUpdate({data: _this.validationModel});
        };

        _this.cleanCodeErrors = function(){
            _this.parentForm.code.$setValidity('invalidcode',true);
        };

        _this.isSendEnabled = function(){
            return _this.parentForm.phone.$invalid || 
                !_this.model.privacyPolicyAccepted || 
                _this.SMSClicked ||
                !( _this.isChina() && _this.model.sensitive_data && _this.model.transfer_data )
        }

        _this.isChina = function(params) {
            return inditex.iCountryCode === 'CN'
        }

    }


    angular.module('itxApp.common')
        .component('itxPhoneAccountCreation', ItxPhoneAccountCreationCmp);

})(window.itxApp);
